import { Status as UIStatus } from '@gogame/components';

import {
  STATUS_NOT_READY,
  STATUS_SYNCED,
  STATUS_REJECTED,
  STATUS_UNKNOWN,
  STATUS_INVALID,
  STATUS_USER_DUPLICATE_ERROR,
} from './constants';

export const getColor = (id) => {
  switch (id) {
    case STATUS_SYNCED:
      return 'success';
    case STATUS_NOT_READY:
      return 'pending';
    case STATUS_REJECTED:
      return 'error';
    case STATUS_INVALID:
      return 'error';
    case STATUS_UNKNOWN:
      return 'draft';
    case STATUS_USER_DUPLICATE_ERROR:
      return 'error';
  }
};

export const Status = ({ id }) => (
  <UIStatus color={getColor(id)}>{id}</UIStatus>
);

export default Status;
